export default function getRelation(personData) {
  // convert ahnentafel number and gender into a relationship lookup key
  const getOrdinal = (n) => {
    const s = ['th', 'st', 'nd', 'rd']
    const v = n % 100
    return n + (s[(v - 20) % 10] || s[v] || s[0])
  }

  const generations = personData && personData.atn ? personData.atn.toString(2).length - 1 : null
  const gender = personData.gender ? personData.gender.toLowerCase() : personData.gender
  let parent = 'UNKNOWN'
  if (gender === 'male') {
    parent = 'father'
  } else if (gender === 'female') {
    parent = 'mother'
  } else {
    parent = 'parent'
  }

  let relation = 'UNKNOWN'
  if (generations === 0) {
    relation = 'self'
  } else if (generations === 1) {
    relation = parent
  } else if (generations === 2) {
    relation = `grand${parent}`
  } else if (generations === 3) {
    relation = `great-grand${parent}`
  } else {
    relation = `${getOrdinal(generations - 2)}-great-grand${parent}`
  }

  return relation
}
